export default {
    metricsDB: {
        name: 'Metrics Dashboard',
        nameOrig: 'Metrics Dashboard (GL)',
        threshold: 'Threshold',
        maxCodes: 'Max Codes',
        maxCodesTT: 'The max number of app codes to display in the graph',
        widgets: {
            frequency: {
                title: 'Endpoints per Frequency',
                subtitle: 'Endpoints on a TBG frequency',
                xAxis: 'Frequency',
                yAxis: 'Number of Endpoints'
            },
            pollResponse: {
                title: 'Endpoints per Poll Response',
                subtitle: 'Endpoints reporting on a TBG frequency',
                xAxis: 'Frequency',
                yAxis: 'Number of Endpoints'
            },
            priority: {
                title: 'Endpoints per Priority',
                subtitle: 'TGBs that are prioritized per endpoint',
                xAxis: 'Frequency',
                yAxis: 'Number of Endpoints'
            },
            downlink: {
                title: 'Endpoints per Downlink',
                subtitle: 'Endpoints that are reporting',
                xAxis: 'Frequency',
                yAxis: 'Number of Endpoints'
            },
            noise: {
                title: 'Idle Noise',
                subtitle: 'Endpoints that are reporting',
                baseStationId: 'ID',
                name: 'Name',
                noiseHeader: 'Noise',
                location: 'Location',
                frequency: 'Frequency',
                noisedb: 'Idle Noise (dB)',
                modulation: 'Modulation',
                receivedDate: 'Date Received',
                minNoise: 'Noise',
                thresholdTT: 'Minimum idle noise for Highest, or maximum idle noise for Lowest'
            },
            radiosHeard: {
                title: 'Radios Heard % Change (Largest recent drop)',
                subtitle: 'Endpoints that are reporting',
                baseStationId: 'ID',
                name: 'Name',
                radiosHeardHeader: 'Radios Heard',
                location: 'Location',
                percentChange: 'Radios Heard Percent Change',
                receivedDate: 'Date Received',
                TT: "Calculated on the last 2 full calendar days. Negative indicates less radios than the day before. Positive is more radios. Zero is the same number as the day before.",
                thresholdTT: 'Minimum percent radios heard for Highest, or maximum percent radios heard for Lowest'
            },
            baseStationLag: {
                title: 'Base Station Lag',
                subtitle: 'Endpoints that are reporting',
                baseStationId: 'ID',
                name: 'Name',
                baseStationLagHeader: 'Base Station Lag (ms)',
                location: 'Location',
                baseStationLag: 'Lag',
                receivedDate: 'Date Received',
                minBaseStationLag: 'Min Lag',
                thresholdTT: 'Minimum Base Station Lag for Highest, or maximum base station lag for Lowest'
            },
            vswr: {
                title: 'VSWR',
                subtitle: 'Endpoints that are reporting',
                baseStationId: 'ID',
                name: 'Name',
                vswrHeader: 'VSWR',
                location: 'Location',
                vswr: 'VSWR',
                receivedDate: 'Date Received',
                minVswr: 'VSWR',
                thresholdTT: 'Minimum VSWR'
            },
            utilityRis: {
                title: "Read Interval Success",
            },
            remoteConnectDisconnectAvgTime: {
                title: "Remote Connect/Disconnect Time",
                tooltip: "Average time for remote connect/disconnect commands whose ACK is received within 30 minutes"
            },
            remoteConnectDisconnectSuccess: {
                title: "Remote Connect/Disconnect Success",
            },
            deviceEsm: {
                title: "ESM Devices"
            },
            baseStationCounts: {
                ackCountsTitle: 'Ack Counts',
                buddyMsgsTitle: 'Highest Buddy Message Counts',
                uniqueBuddyMsgsTitle: 'Unique Buddy Messages',
                dupBuddyMsgsTitle: 'Duplicate Buddy Messages',
                transmitCountsTitle: 'Downlink Commands Sent',
                receiveCountsTitle: 'Uplink Messages Received',
                commandInCountsTitle: 'Downlink Commands Received',
                commandOutCountsTitle: 'Downlink Commands Queued',
                commandOutCountsTT: 'Base Station ===> End Point',
                commandInCountsTT: 'RNI ===> Base Station',
                transmitCountsTT: 'Base Station ===> End Point',
                receiveCountsTT: 'Base Station <=== End Point',
                thresholdTT: 'Minimum count for Highest, or maximum count for Lowest',
                highestThresholdTT: 'Minimum count',
                highValueTitle: 'Minimum threshold',
                lowValueTitle: 'Maximum threshold',
                highLowTitle: 'Display Highest or Lowest base station counts',
                name: 'Name',
                noiseHeader: 'Noise',
                location: 'Location',
                frequency: 'Frequency',
                count: 'Count',
                counts: 'Counts',
                modulation: 'Modulation',
                received: 'Date Received',
                minCounts: 'Counts'
            }
        }
    }
}
